<template>
  <el-container class="layout-container">
    <!-- 顶部导航 -->
    <el-header class="layout-header">
      <div class="header-left">
        <img src="@/assets/logo.png" alt="Logo" class="logo" />
        <h1 class="system-title">君品集团能碳智能管理平台</h1>
      </div>
      <div class="header-right">
        <span class="app-version">v{{ version }}</span>
        <el-dropdown trigger="click" @command="handleCommand">
          <span class="user-info">
            <i class="el-icon-user-solid"></i>
            {{ userInfo ? userInfo.userName : '管理员' }}
            <i class="el-icon-arrow-down"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="profile">个人中心</el-dropdown-item>
            <el-dropdown-item divided command="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-header>

    <el-container>
      <!-- 左侧菜单 -->
      <el-aside :width="sidebarOpened ? '210px' : '64px'" class="layout-aside">
        <Sidebar />
      </el-aside>

      <!-- 主内容区 -->
      <el-main class="layout-main">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { mapGetters } from 'vuex'
import Sidebar from './Sidebar.vue'
import pkg from '../../package.json'

export default {
  name: 'Layout',
  components: { Sidebar },
  data() {
    return {
      version: pkg.version
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'sidebarOpened'])
  },
  methods: {
    handleCommand(cmd) {
      if (cmd === 'profile') {
        if (this.$route.path !== '/account/profile') {
          this.$router.push('/account/profile')
        }
      } else if (cmd === 'logout') {
        this.$confirm('确定退出登录？', '提示', { type: 'warning' })
          .then(() => {
            this.$store.dispatch('user/logout').then(() => {
              this.$router.push('/login')
            })
          })
          .catch(() => {})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.layout-container {
  height: 100%;
}
.layout-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #001529;
  color: #fff;
  padding: 0 20px;
  height: 60px !important;
  .header-left {
    display: flex;
    align-items: center;
    .logo {
      height: 32px;
      margin-right: 12px;
    }
    .system-title {
      font-size: 18px;
      font-weight: 600;
      color: #fff;
    }
  }
  .header-right {
    display: flex;
    align-items: center;
    .app-version {
      color: rgba(255, 255, 255, 0.55);
      font-size: 12px;
      margin-right: 16px;
    }
    .user-info {
      color: #fff;
      cursor: pointer;
      font-size: 14px;
      i { margin: 0 4px; }
    }
  }
}
.layout-aside {
  background: #001529;
  overflow-y: auto;
  overflow-x: hidden;
  transition: width 0.3s;
}
.layout-main {
  background:
    radial-gradient(ellipse at 20% 0%, rgba(30, 120, 200, 0.18) 0%, transparent 55%),
    radial-gradient(ellipse at 80% 100%, rgba(0, 210, 255, 0.10) 0%, transparent 55%),
    linear-gradient(180deg, #061428 0%, #0a2340 50%, #061024 100%);
  color: #dbeaf5;
  padding: 20px;
  overflow-y: auto;
}
</style>
